import React, { useState } from 'react';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container, Table } from '@mui/material';
import { GiCheckMark } from "react-icons/gi";
import "./eligibility.css";
import { color } from 'highcharts';

const CompatibilityCheck = () => {
  const [loading, setLoading] = useState(false);
  const [vinNumber, setVinNumber] = useState('');
  const [responseData, setResponseData] = useState(null);
  const [eligible, setEligible] = useState(null);

  const handleSubmitForm = async (e) => {
    e.preventDefault();

    if (vinNumber.toString().trim() === '') {
      alert('Please enter VIN Number.');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/check_vin_compatibility`, {
        vin: vinNumber.toString().trim(),
      });

      setLoading(false);
    //   const transformedData = transformResponse(res.data);
      setResponseData(res.data);
    //   setEligible(res.data.eligible);

      // setVinNumber('');
    } catch (error) {
      setLoading(false);
      setResponseData(null);
      setEligible(null);
    }
  };

//   const transformResponse = (data) => {
//     const transformed = {};
//     for (const [key, value] of Object.entries(data)) {
//       if (Array.isArray(value) && value.length === 0) {
//         transformed[key] = 'N/A';
//       } else if (value === '') {
//         transformed[key] = 'N/A';
//       } else {
//         transformed[key] = Array.isArray(value) ? value.join(', ') : value;
//       }
//     }

//     if (transformed["availableRemoteCommands"] !== undefined) {
//       transformed["Remote Commands"] = transformed["availableRemoteCommands"];
//       delete transformed["availableRemoteCommands"];
//     }
//     if (transformed["offers"] !== undefined) {
//       transformed["Package"] = transformed["offers"];
//       delete transformed["offers"];
//     }
//     return transformed;
//   };
  
  const renderTable = () => {
    if (!responseData || !Array.isArray(responseData)) return null;

    return (
        <Table bordered hover className="eligible-response-table">
          <thead>
            <tr>
              <th>VIN</th>
              <th>Make</th>
              <th>Model</th>
              <th>Model Year</th>
              <th>Fuel Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {responseData.map((vehicle, index) => (
              <tr key={index} className={vehicle.status === 'Compatible' ? 'table-success' : 'table-danger'}>
                <td>{vehicle.vin || ''}</td>
                <td>{vehicle.make || ''}</td>
                <td>{vehicle.model || ''}</td>
                <td>{vehicle.modelyear || ''}</td>
                <td>{vehicle.fueltype || ''}</td>
                <td>{vehicle.status || ''}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
  };

  return (
    <div className="body_class">
      {loading && (
        <div className="loader-overlay">
          <div className="loader">
            <PuffLoader color="#00308F" loading={true} size={200} />
          </div>
        </div>
      )}
      <div className="container-fluid">
        <h4>Check Vehicle Compatibility</h4>
        <div className="mt-4">
          <div className="container-fluid">
            <Form onSubmit={handleSubmitForm}>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                <Form.Label column sm="2">
                  VIN Number *
                </Form.Label>
                <Col sm="5">
                  <Form.Control
                    type="text"
                    value={vinNumber}
                    onChange={(e) => setVinNumber(e.target.value)}
                    placeholder="Enter VIN Number"
                  />
                  <span>For multiple VINs, separate each with a comma.</span>
                </Col>
                
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                <Form.Label column sm="2"></Form.Label>
                <Col sm="5">
                  <Button variant="contained" type="submit">
                    <GiCheckMark />&nbsp;Check
                  </Button>
                </Col>
              </Form.Group>
            </Form>
          </div>
        </div>
        <div className="mt-4">
            <div className="container-fluid">
                <div class="table-title">
                <h5>Compatibility API Response</h5>
                {renderTable()}
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default CompatibilityCheck;